"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureMonitorSpanProcessor = void 0;
const index_js_1 = require("../shared/logging/index.js");
/**
 * Azure Monitor Span Processor.
 * @internal
 */
class AzureMonitorSpanProcessor {
    _metricHandler;
    constructor(metricHandler) {
        this._metricHandler = metricHandler;
    }
    forceFlush() {
        return Promise.resolve();
    }
    onStart(span, _context) {
        this._metricHandler.markSpanAsProcessed(span);
    }
    onEnd(span) {
        try {
            this._metricHandler.recordSpan(span);
        }
        catch (error) {
            index_js_1.Logger.getInstance().warn("Error while recording span", error);
        }
    }
    shutdown() {
        return Promise.resolve();
    }
}
exports.AzureMonitorSpanProcessor = AzureMonitorSpanProcessor;
//# sourceMappingURL=spanProcessor.js.map